/* src/app/system-utils/prompt-save-dialog/prompt-save-dialog.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  gap: var(--tem-space-2);
}
.content-container {
  width: 100%;
}
.field-error {
  color: var(--tem-danger);
  font-size: var(--tem-fs-sm);
  margin-top: var(--tem-space-1);
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.options {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  padding: 10px;
  gap: 10px;
  align-items: flex-end;
}
/*# sourceMappingURL=prompt-save-dialog.component.css.map */
